import uuid from '../uuid';

import { type AddOptions, type ItemWrapperType } from './types';

export const convertToItemWrapper = <T>(
	item: T,
	namespace: string,
	{ id, retryAttempts, timeToProcessOffset }: AddOptions,
): ItemWrapperType<T> => ({
	item,
	id: id || uuid(),
	retryAttempts: retryAttempts || 0,
	timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
	namespace,
	timeAdded: Date.now(),
});
